import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { AlertTriangle } from "react-feather";
import styles from "./deletePopup.module.css";

const DeletePopup = ({ open, setOpen, confirmAction, title, message, btnText, cancelText }) => {

  return (<Dialog
    open={open}
    onClose={(e) => setOpen(false)}
    fullWidth
    maxWidth="xs"
    className={`${styles.NewPopUp}`}
  >
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      {title || "Delete Item?"}
      <IconButton onClick={(e) => setOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText component="div">
        <div className={`${styles.Body}`}>
          <div className={`${styles.IconWrap}`}>
            <AlertTriangle />
          </div>
          <p className={`${styles.BodyText}`}>{message || "Are you sure you want to delete this item? You can't undo this action."}</p>
        </div>
      </DialogContentText>
    </DialogContent>
    <DialogActions className={`${styles.Actions}`}>
      <Button className={`${styles.CancelPopupBU}`} onClick={(e) => setOpen(false)}>{cancelText || "Cancel"}</Button>
      <Button className={`${styles.SubmitPopupBU}`} onClick={(e) => { setOpen(false); confirmAction(); }}>{btnText || "Delete"}</Button>
    </DialogActions>
  </Dialog>);
};

export default DeletePopup;